import React, { useState } from "react";
import { Box, Typography, TextField, IconButton } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Logo from "../../assets/logo-white.webp";
import { Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { emailRegex } from "../../constants/regex";
import Toast from "../toast";
import { saveNewLetterSubscription } from "../../helpers/NewLetterSubscription";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToSection } from "../../constants/LandingUtils";

const navItems = [
  { label: "Home", sectionId: "home" },
  { label: "About", sectionId: "about" },
  { label: "Services", sectionId: "services" },
  { label: "Testimonials", sectionId: "testimonials" },
  { label: "Contact", sectionId: "contact" },
];

export function Footer() {
  const [emailAddress, setemailAddress] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(sectionId), 300);
      return;
    }
    scrollToSection(sectionId);
  };

  const hanleSaveSubscription = async () => {
    try {
      if (!emailRegex.test(emailAddress)) {
        Toast.error("Enter a valid email address.");
        return;
      }

      const response = await saveNewLetterSubscription({
        emailAddress: emailAddress,
      });
      if (response.statusCode === 200 && response.isSuccess === true) {
        Toast.success(response.message);
      } else {
        Toast.error(response.message);
      }
      setemailAddress("");
    } catch (error) {
      Toast.error(error.message);
    }
  };
  return (
    <Box
      sx={{
        borderRadius: "24px",
        background: "#000000",
        color: "#fff",
        px: { xs: 1.5, md: 3 },
        py: { xs: 1, md: 3 },
      }}
    >
      {/* TOP ROW */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "start",
          justifyContent: { xs: "center", sm: "space-between" },
          gap: 4,
          mb: 3,
        }}
      >
        {/* LEFT */}
        <Box sx={{ maxWidth: { xs: "100%", md: "300px" }, textAlign: { xs: "center", md: "left" } }}>
          <img
            src={Logo}
            alt="Logo"
            style={{ width: "100%", maxWidth: "180px", marginBottom: 3 }}
          />

          <Typography fontSize={12} color="#aaa">
            Simplifying healthcare through intelligent, user-friendly
            assistance. We help patients navigate medical forms, appointments,
            and everyday health tasks with clarity and confidence.
          </Typography>
        </Box>

        {/* NAV */}
        <Box
          sx={{
            display: "flex",
            gap: { xs: 1 },
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {navItems.map((item) => (
            <Typography
              key={item.label}
              component="span"          
              onClick={() => handleNavClick(item.sectionId)}  
              sx={{
                textDecoration: "none",
                cursor: "pointer",
                px: 1.5,
                py: 0.6,
                color: "#fff",
                borderRadius: "20px",
                border: "1px solid #444",
                fontSize: 13,
                fontWeight: 500,
                "&:hover": {
                  color: "#5e60e4",
                  borderRadius: "40px",
                  background:
                    "linear-gradient(180deg, #c4c8ff45 30%, #868df563 100%)",
                  borderColor: "#C4C8FF",
                  borderBottomColor: "#7b7de5ab",
                  boxShadow:
                    "inset 0px -2px 1px #979EFF66, inset 0px 2px 1px #ffffff66, 0px 2px 15px #979EFF66",
                },
              }}
            >
              {item.label}
            </Typography>
            // <Box
            //   key={item.label}
            //   sx={{
            //     px: 2,
            //     py: 0.6,
            //     borderRadius: "20px",
            //     border: "1px solid #444",
            //     fontSize: 14,
            //     cursor: "pointer",

            //     "&:hover": {
            //       borderColor: "#fff",
            //     },
            //   }}
            // >
            //   {item.label}
            // </Box>
          ))}
        </Box>

        {/* NEWSLETTER */}
        <Box sx={{ minWidth: "280px", maxWidth: { xs: "100%", sm: "400px", md: "300px" }, width: "100%" }}>
          <Typography fontSize={13} mb={1}>
            Subscribe to our newsletter
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #444",
              borderRadius: "30px",
              pl: 1,
              pr: 0.5,
            }}
          >
            <TextField
              variant="standard"
              placeholder="Enter your email"
              value={emailAddress}
              onChange={(e) => setemailAddress(e.target.value)}
              InputProps={{ disableUnderline: true }}
              sx={{
                px: 1,
                py: 0.6,
                fontSize: 13,
                flex: 1,
                input: { color: "#fff" },
              }}
            />

            <IconButton
              sx={{
                background: "#6C63FF",
                color: "#fff",
                width: 32,
                height: 32,
                "&:hover": { background: "#5A52E0" },
              }}
              onClick={hanleSaveSubscription}
            >
              <ArrowForwardIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </Box>

      {/* BOTTOM BAR */}
      <Box
        sx={{
          mt: 3,
          backgroundColor: "#7B7DE5",
          borderRadius: "40px",
          p: 1.5,
          display: "flex",
          justifyContent: { xs: "center", sm: "space-between" },
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: { xs: "column-reverse", sm: "row" },
          gap: 2,
        }}
      >
        <Typography
          fontSize={12}
          sx={{ textAlign: { xs: "center", sm: "left" } }}
        >
          © 2026. All rights reserved &nbsp; | &nbsp;
          <MuiLink
            component={RouterLink}
            to="/privacy"
            underline="hover"
            color="inherit"
          >
            Privacy Policy
          </MuiLink>
          &nbsp; | &nbsp;
          <MuiLink
            component={RouterLink}
            to="/terms"
            underline="hover"
            color="inherit"
          >
            Terms & Conditions
          </MuiLink>
        </Typography>

        {/* SOCIALS */}
        <Box sx={{ display: "flex", gap: 1 }}>
          {[FacebookIcon, InstagramIcon, LinkedInIcon, WhatsAppIcon].map(
            (Icon, i) => (
              <Box
                key={i}
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: "50%",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#6C63FF",
                  cursor: "pointer",
                  "&:hover": { background: "#CCCCFE" },
                }}
              >
                <Icon fontSize="small" />
              </Box>
            ),
          )}
        </Box>
      </Box>
    </Box>
  );
}
